var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTriangleBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80762 1.46446C11.7603 -0.488153 14.926 -0.488153 16.8787 1.46446L25.2219 9.80757C27.1744 11.7602 27.1744 14.926 25.2219 16.8787L16.8787 25.2218C14.926 27.1744 11.7603 27.1744 9.80761 25.2218L1.46446 16.8787C-0.488155 14.926 -0.488155 11.7602 1.46447 9.80757L9.80762 1.46446ZM14.3431 9.3431C14.3431 8.79082 13.8954 8.3431 13.3431 8.3431C12.7908 8.3431 12.3431 8.79082 12.3431 9.3431V12.3431H9.3431C8.79082 12.3431 8.3431 12.7908 8.3431 13.3431C8.3431 13.8954 8.79082 14.3431 9.3431 14.3431H12.3431V17.3431C12.3431 17.8954 12.7908 18.3431 13.3431 18.3431C13.8954 18.3431 14.3431 17.8954 14.3431 17.3431V14.3431H17.3431C17.8954 14.3431 18.3431 13.8954 18.3431 13.3431C18.3431 12.7908 17.8954 12.3431 17.3431 12.3431H14.3431V9.3431Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTriangleBox);
export default __webpack_public_path__ + "static/media/add_triangle_box.74169233ba8a8aabdfe57672e35d313f.svg";
export { ForwardRef as ReactComponent };